import { environment } from '@/environments/environment';
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDataTestid]',
})
export class DataTestidDirective {
  _appDataTestid!: string;

  @Input()
  set appDataTestid(value: string | number | null) {
    this._appDataTestid = String(value);
    this.updateTestid();
  }
  get appDataTestid(): string | number | null {
    return this._appDataTestid;
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  updateTestid() {
    if (!environment.production && this._appDataTestid) {
      this.renderer.setAttribute(
        this.elementRef.nativeElement,
        'data-testid',
        this._appDataTestid,
      );
    }
  }
}
